export const MAP_BASE_WIDTH = 760;
export const MAP_BASE_HEIGHT = 793;
export const BOOKED_BY_MODAL_WIDTH = 164
export const BOOKED_BY_MODAL_HEIGHT = 89